const SubscribeMessage = {
  SUCCESS: 'Заявка принята',
  ERROR: 'Произошла ошибка, повторите попытку позже',
};

export {
  SubscribeMessage,
};
